import React from 'react';
import { withApollo } from "react-apollo";

class ColumnFeed extends React.Component {
    
    constructor(props) {
		super(props);
		this.commentColumn = React.createRef();
		this.handleScroll = this.handleScroll.bind(this);
	}

	handleScroll(e) {
        const col = this.commentColumn.current;
		if(Math.ceil(col.scrollTop) >= col.scrollHeight - col.clientHeight) {
			this.props.onReachBottom();
		}
	}

	render() {

		let className = 'col col-2';
		if(this.props.className) className += ' ' + this.props.className;

		return (
			<div className={className} onScroll={this.handleScroll} ref={this.commentColumn}>
				{this.props.children}
			</div>
      	)
	}
};

export default withApollo(ColumnFeed)


// WEBPACK FOOTER //
// ./src/components/chunk/ColumnFeed.js